export default __webpack_public_path__ + "08e956bd7fa428faec6d0e61053c0a45.png";